<div *ngFor="let matrix of matrices" class="matrix-block mb-4">
  <div class="matrix-title-row">
    <span class="matrix-icon">
      <i class="icon-grid"></i>
    </span>
    <label class="form-label matrix-label">{{ matrix.label }}</label>
  </div>

  <!-- Copy buttons (editable mode: new campaign or draft/paused) -->
  <div class="copy-buttons-row" *ngIf="!campaignData || campaignData?.stage == 'paused' || campaignData?.stage == 'draft'">
    <button
      *ngFor="let target of getOtherMatrices(matrix)"
      type="button"
      class="btn-copy"
      (click)="copyToMatrix(matrix, target)">
      <i class="icon-copy"></i>
      {{ "forms.buttons.copy_to" | translate }} {{ target.label }}
    </button>
  </div>

  <!-- Editable mode -->
  <div *ngIf="!campaignData || campaignData?.stage == 'paused' || campaignData?.stage == 'draft'">
    <div class="tabla">
      <table class="full-width-table table-fixed">
        <thead>
          <tr>
            <th class="px-2 py-1 cabecera-tabla">KMS / Duration</th>
            <th *ngFor="let h of getHeaders(matrix.form).controls; trackBy: trackByIndex" class="px-2 py-1 cabecera-tabla">
              {{ h.value }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of getRows(matrix.form).controls; let r = index; trackBy: trackByIndex">
            <td class="px-2 py-1 row-label-cell">
              {{ row.get('label')?.value }}
            </td>
            <td *ngFor="let _ of row.get('cells')?.value; let c = index; trackBy: trackByIndex" class="px-1">
              <input [formControl]="getCellControl(matrix.form, r, c)" class="inputs border px-1" type="text" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Read-only mode -->
  <div *ngIf="campaignData && campaignData?.stage != 'paused' && campaignData?.stage != 'draft'">
    <div class="tabla">
      <table class="full-width-table table-fixed">
        <thead>
          <tr>
            <th class="px-2 py-1 cabecera-tabla">KMS / Duration</th>
            <th *ngFor="let h of getHeaders(matrix.form).controls; trackBy: trackByIndex" class="px-2 py-1 cabecera-tabla">
              {{ h.value }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of getRows(matrix.form).controls; let r = index; trackBy: trackByIndex" class="px-2 py-1 cabecera-tabla">
            <td class="px-2 py-1 row-label-cell">
              {{ row.value.label }}
            </td>
            <ng-container *ngIf="row.get('cells')">
              <td *ngFor="let cell of row.get('cells')?.value; let c = index; trackBy: trackByIndex" class="px-2 py-1 cabecera-tabla">
                {{ cell }}
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
